import { useState } from 'react';

// This hook allows for it to be used to generate obj that will alter itself only when it's "trigger" method is called thus
// giving us a way to use it "like" event. You can also pass argument in trigger function, it will be accesible through event.payload.
// Just generate the event obj:
//
// const event = useEvent();
//
// Pass it as prop to desired component, listen of in using useEffectAfterMount (You can use useEffect, but it will be triggered on init as well)
//
// useEffectAfterMount(() => {
// doSomeStuff(event.payload); // event.payload = "CATS !";
// }, [event])
//
// Trigger it:
// event.trigger('CATS !');
//
// That's it. Have a nice day :)

type TriggerFn = (payload?: any) => void;

export const useEvent: () => { trigger: TriggerFn; payload: any } = () => {
  const [event, setEvent] = useState({
    // eslint-disable-next-line no-use-before-define
    trigger,
    payload: null,
  });

  // This is prime place for using hoisting in our advantage resolving in function beeing able use variables based on itself
  function trigger(payload = null) {
    setEvent({ trigger, payload });
  }

  return event;
};

export default useEvent;
